// @flow

const MAP_CENTER_IN_ZONE = "map/center/inzone/update";
const MAP_CENTER_UPDATE = "map/center/update";
const MAP_LOADING_DONE = "map/loading/done";
const MAP_FOCUS_BOUNDS = "map/focus/bounds";
const MAP_FOCUS_LATLNG = "map/focus/latlng";

export default {
    MAP_CENTER_IN_ZONE,
    MAP_CENTER_UPDATE,
    MAP_LOADING_DONE,
    MAP_FOCUS_BOUNDS,
    MAP_FOCUS_LATLNG,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/MapData/types.js